// extracted by mini-css-extract-plugin
module.exports = {"styledTableHeader":"FMBqabOT","isOver":"x4dXrEXx","hoverEnabled":"xdRmukv8","hasTooltip":"K_ri5d9Q"};